import { createSelector } from '@reduxjs/toolkit';

import {
  GET_DEFAULT_FILTERS,
  GET_DEFAULT_FILTERS_WITH_FEATURE_MODEL,
} from '@/constants/filters';
import PAGES from '@/constants/pages';
import currentPageSelector from '@/features/installation/selectors/currentPage';
import { ConstructorEnum, FilterRootGridType } from '@/interfaces/constructor.interfaces';
import GridUtils from '@/utils/gridUtils';
import instanceOfGrid from '@/utils/instanceOfGrid';

import constructorSelector from './constructor';

/**
 * Получить сгрупированные фильтры по блокам из настроек приложения
 */
const filterGridSelector = createSelector(
  [constructorSelector, currentPageSelector],
  (gridConstructor, page = PAGES.Cars) => {
    let pageWithFilterGrid: typeof PAGES.Cars | typeof PAGES.Models = PAGES.Cars;
    let fallbackFilterGrid = GET_DEFAULT_FILTERS;

    if (PAGES.Models === page) {
      pageWithFilterGrid = page;
      fallbackFilterGrid = GET_DEFAULT_FILTERS_WITH_FEATURE_MODEL;
    }

    const filterGrid =
      GridUtils.findByCondition(
        gridConstructor[pageWithFilterGrid],
        e => instanceOfGrid(e) && e.type === ConstructorEnum.Filters,
      ) ?? fallbackFilterGrid();

    return filterGrid as FilterRootGridType;
  },
);

export default filterGridSelector;
